const topicsList = [
  { name: '网红爆料', count: '326条', hot: true },
  { name: '明星八卦', count: '258条', hot: true },
  { name: '综艺揭秘', count: '189条', hot: true },
  { name: 'MCN深挖', count: '147条', hot: false },
  { name: 'AI换脸', count: '112条', hot: true },
  { name: '数字人侵权', count: '95条', hot: false },
  { name: '影视扒皮', count: '83条', hot: false },
  { name: '商业爆料', count: '71条', hot: true },
  { name: '法律观察', count: '58条', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最受关注的黑料话题标签，点击探索更多内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsList.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`group inline-flex items-center gap-2 px-5 py-3 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-white border-background-200 hover:border-background-300 hover:bg-background-50'
              }`}
            >
              {item.hot && (
                <i className="ri-fire-line text-sm text-primary-500"></i>
              )}
              <span className={`text-sm font-medium ${item.hot ? 'text-primary-700' : 'text-foreground-700'}`}>
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}